// @flow
import * as React from 'react';
import styled from 'styled-components';
import { format, parseISO } from 'date-fns';
import {
  GRAD_FAIRS as FAIR_LOCATIONS,
  GRAD_FAIR_NAME_MAP
} from 'utils/constants/gradFairs';
import Box from 'components/Box';
import { ConditionalLink } from 'components/Link';
import { bannerIsDismissed } from 'components/GradFairsBanner';
import { Body, BodySmall } from 'components/Text';
import { dayAndMonth, dateIsUpcoming, dateIsToday } from 'utils/date';
import { trackClicked } from 'utils/analytics';
import { colors } from '../theme';

const FAIRS = [
  {
    month: getText('September'),
    locations: FAIR_LOCATIONS.filter(
      location => format(parseISO(location.date), 'M') === '9'
    )
  },
  {
    month: getText('October'),
    locations: FAIR_LOCATIONS.filter(
      location => format(parseISO(location.date), 'M') === '10'
    )
  }
];

const getUrl = url => `${url}?utm_medium=Idealist&utm_source=LeftRailAd`;

const FairLink = styled(Box)`
  ${({ $today }) =>
    $today &&
    `
    background-image: linear-gradient(to bottom, ${colors.dandelion} 0%, ${
      colors.dandelion
    } 100%);
    background-position: 0 1em;
    background-repeat: repeat-x;
    background-size: 100% 0.2em;
  `}
`;

const GradFairsLinks = ({
  searchLocation,
  ...props
}: {
  searchLocation: ?SearchLocation
}) => {
  if (
    !FAIRS.some(fair =>
      fair.locations.some(location => dateIsUpcoming(location.date))
    )
  ) {
    return null;
  }

  const hideBanner = bannerIsDismissed();

  return (
    <Box {...props}>
      <Body>{getText('Grad School Fairs 2020')}</Body>
      <Box display="flex" width={1} mt={16} pb={hideBanner ? 0 : 30}>
        {FAIRS.map(fair =>
          fair.locations.some(location => dateIsUpcoming(location.date)) ? (
            <Box width={1 / 2} key={fair.month} pr={10}>
              <BodySmall>{fair.month}</BodySmall>
              {fair.locations.map(location => {
                const active = dateIsUpcoming(location.date);
                const today = dateIsToday(location.date);
                return (
                  <BodySmall
                    key={location.date}
                    textOverflow="ellipsis"
                    overflow="hidden"
                    whiteSpace="nowrap"
                  >
                    <ConditionalLink
                      link={active ? getUrl(location.url) : null}
                      onClick={() => {
                        if (active) {
                          trackClicked('Search Sidebar Grad Fairs Links', {
                            location: GRAD_FAIR_NAME_MAP[location.id]
                          });
                        }
                      }}
                      target="_blank"
                    >
                      <FairLink
                        display="inline"
                        mr="4px"
                        color={!active && colors.battleshipGrey}
                        opacity={!active && 0.75}
                        $today={today}
                      >
                        <Box component="span">{dayAndMonth(location.date)}</Box>
                      </FairLink>
                    </ConditionalLink>
                  </BodySmall>
                );
              })}
            </Box>
          ) : null
        )}
      </Box>
    </Box>
  );
};

export default GradFairsLinks;
